module.exports = __webpack_public_path__ + "static/media/portfolife.fb524c7d.png";